export default __webpack_public_path__ + "static/media/singer.3d9cfb82.png";